import { DoudianGiftLateDeliveryInfo } from "@/dto/order/DouDianOrderExtraInfoDTO";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import moment from "moment";
import React from "react";

interface DouDianGiftLateDeliveryInfoProps {
    order: OrderDTO;
    orderItem: OrderItemDTO;
}

function findGiftLateDeliveryInfoByOrderItemOriginalId(
    giftLateDeliveryInfoList: DoudianGiftLateDeliveryInfo[],
    orderItemOriginalId: string,
): DoudianGiftLateDeliveryInfo | undefined {
    return giftLateDeliveryInfoList.find((info) => info.orderItemOriginalId === orderItemOriginalId);
}

const DouDianGiftLateDeliveryInfo: React.FC<DouDianGiftLateDeliveryInfoProps> = function (props) {
    const { order, orderItem } = props;

    if (!order.doudianOrderExtraInfo?.giftLateDeliveryInfoList?.length) return null;

    const orderItemLatestGiftLateDeliveryInfo: DoudianGiftLateDeliveryInfo = findGiftLateDeliveryInfoByOrderItemOriginalId(
        order.doudianOrderExtraInfo.giftLateDeliveryInfoList,
        orderItem.originalId,
    );

    if (!orderItemLatestGiftLateDeliveryInfo) return null;

    function buildShippedOrderGiftLateDeliveryInfo() {
        try {
            let timestamp = orderItemLatestGiftLateDeliveryInfo.givenExpShipTime;

            if (!timestamp) return null;

            // 如果是秒级（通常小于 10 位数字范围），则乘以 1000 转成毫秒
            // 1e12 对应的是 2001-09-09T01:46:40.000Z 之前的毫秒数
            if (timestamp < 1e12) {
                timestamp = timestamp * 1000;
            }

            return `赠品需在${moment(timestamp).format("YYYY/MM/DD HH:mm:ss")}前发货`;
        } catch {
            return null;
        }
    }

    return (
        <p className="fs13 fb text-error">
            赠品后发:
            {!orderItemLatestGiftLateDeliveryInfo.givenExpShipTime
                ? orderItemLatestGiftLateDeliveryInfo.givenExpShipTimeDesc
                : buildShippedOrderGiftLateDeliveryInfo()}
        </p>
    );
};

export default React.memo(DouDianGiftLateDeliveryInfo);
